export enum TagType {
  ASSET_TAG = 0,
  TRIBUTE_VIDEO_TAG = 1,
  THEME_TAG = 2
}
